/** Shared permission resource definitions (client) */

export const PERMISSION_RESOURCES = [
  { value: 'wqms_dashboard', label: 'Dashboard', group: 'General' },
  { value: 'stations', label: 'All Stations', group: 'Stations' },
  ...Array.from({ length: 15 }, (_, i) => ({
    value: `station:${i + 1}`,
    label: `WQMS-${i + 1}`,
    group: 'Stations',
  })),
  { value: 'report:monthly-wqi', label: 'Monthly WQI', group: 'Reports' },
  { value: 'report:compare-2y', label: '2Y Plot', group: 'Reports' },
  { value: 'report:exceedance', label: 'Exceedance Report', group: 'Reports' },
  { value: 'report:river-compare', label: 'Parameters Comparison', group: 'Reports' },
  { value: 'report:river-vs-river', label: 'Rivers Comparison', group: 'Reports' },
  { value: 'report:river-longitudinal', label: 'Upstream / Downstream', group: 'Reports' },
  { value: 'users:dashboard', label: 'Users Dashboard', group: 'Administration' },
  { value: 'users:create', label: 'Create Users', group: 'Administration' },
  { value: 'permissions:manage', label: 'Manage Access', group: 'Administration' },
];

export const resourceLabel = (value) =>
  PERMISSION_RESOURCES.find((r) => r.value === value)?.label || value;

/** Menu items shown in the dashboard drawer based on granted access */
export const MENU_ITEMS = [
  { label: 'Rivers Upstream Downstream Analysis', permission: 'report:river-longitudinal', path: '/reports/river-longitudinal', section: 'Reports' },
  { label: 'Rivers Comparison', permission: 'report:river-vs-river', path: '/reports/river-vs-river', section: 'Reports' },
  { label: 'Parameters Comparison', permission: 'report:river-compare', path: '/reports/river-compare', section: 'Reports' },
  { label: '2Y Plot', permission: 'report:compare-2y', path: '/reports/compare-2y', section: 'Reports' },
  { label: 'Monthly WQI', permission: 'report:monthly-wqi', path: '/reports/monthly-wqi', section: 'Reports' },
  { label: 'Exceedance Report', permission: 'report:exceedance', path: '/reports/exceedance', section: 'Reports' },
  { label: 'Users', permission: 'users:dashboard', path: '/users', section: 'Administration' },
  { label: 'Manage Access', permission: 'permissions:manage', action: 'permissions', section: 'Administration' },
];
